<template>
  <!--outlets modal-->
  <div
    id="product-landing-page"
    :class="[itemModifierGroups(item).length ? '' : 'without-modifier']"
  >
    <!-- <a href="javascript:void(0)" class="sidebar-overlay" @click="close()"></a> -->
    <div
      v-if="productDetailsPage"
      class="modal-dialog-centered customized-modal"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-body ratio_portrait product_page">
          <Top></Top>
          <div class="customized-detail">
            <ItemInfo></ItemInfo>
            <Modifiers></Modifiers>
            <Bottom></Bottom>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Top from './ProductLandingPage/ItemDetail/Top'
import ItemInfo from './ProductLandingPage/ItemDetail/ItemInfo'
import Modifiers from './ProductLandingPage/ItemDetail/SelectModifiers'
import Bottom from './ProductLandingPage/ItemDetail/Bottom'
export default {
  name: 'ProductLandingPage',
  components: {
    Top,
    ItemInfo,
    Modifiers,
    Bottom,
  },

  computed: {
    ...mapState({
      item: state => state.cart_store.selectedItem,
      productDetailsPage: state => state.brand_store.productDetailsPage,
    }),
    ...mapGetters([
      '_T_DB',
      '_T',
      'itemModifierGroups',
      'itemModifierSubGroups',
      'itemModifiers',
    ]),
  },
  data() {
    return {
      closepopup: false,
      selectSingleItemClick: '',
    }
  },
  props: { isModalVisible: Boolean },
  methods: {
    close() {
      this.$store.commit('SET_ITEM_DETAIL_POPUP')
      document.body.classList.remove('body-overlay')
    },
  },
}
</script>

<style lang="scss">
.product_page {
  display: grid;
  grid-template-columns: 1fr 2fr;
  grid-column-gap: $px30;
  padding: $px20 $px48 !important;
}
.modifier-side-popup {
  box-shadow: 0 0 $px8 rgba($black, 0.55);
  position: fixed;
  margin: auto;
  right: -$px600 !important;
  width: $px600 !important;
  max-width: $px600 !important;
  height: 100vh;
  top: 0;
  z-index: 99;
  transition: opacity 0.3s linear, right 0.3s ease-out !important;
  &.open-popup {
    right: 0 !important;
    .sidebar-overlay {
      opacity: 0.5;
      display: block;
    }
  }
  .sidebar-overlay {
    background-color: $black;
    position: fixed;
    z-index: -1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transition: all 1s;
    opacity: 0;
    display: none;
  }
  .customized-modal {
    &.show {
      .modal-dialog {
        right: 0 !important;
      }
    }
    &.modal-dialog {
      max-width: 100%;
      margin: 0;
      // @extend %default-scroll-lg;
      .modal-content {
        scroll-behavior: smooth;
        height: 100vh;
        overflow: auto;
        padding-bottom: $px50;
        border: none;
        border-radius: 0;
        @media (max-width: 575px) {
          padding-bottom: 0 !important;
        }
        /* width */
        ::-webkit-scrollbar {
          width: $px6;
        }
        /* Track */
        ::-webkit-scrollbar-track {
          background: $scrollbar-track;
          border-radius: $px6;
        }
        /* Handle */
        ::-webkit-scrollbar-thumb {
          background: $scrollbar-thumb;
          border-radius: $px4;
        }
        /* Handle on hover */
        ::-webkit-scrollbar-thumb:hover {
          background: darken($scrollbar-track, 0.2);
        }
      }
    }
    .modal-body {
      padding: 0;
      width: 100%;
      .customized-detail {
        padding: $px20;
        overflow: auto;
        background-color: $white;
        &::-webkit-scrollbar {
          width: 0 !important ;
        }
      }
    }
  }
}
@media (max-width: 1367px) {
  .modifier-side-popup {
    right: -$px500 !important;
    width: $px500 !important;
    max-width: $px500 !important;
  }
}
@media (max-width: 991px) {
  .product_page {
    display: block;
    margin: auto;
    padding: $px16 !important;
  }
  .modifier-side-popup {
    .modal-dialog {
      margin: 1.75rem auto;
      right: 0;
      left: 0;
      width: auto;
      height: unset;
      position: unset;
      transform: translate(0, 0) !important;
      .modal-content {
        height: auto;
        padding-bottom: 0;
        max-height: unset;
        overflow: unset;
        // border-radius: 0.3rem !important;
      }
    }
    .modal-body {
      display: block;
      .content-header {
        padding: $px12 $px18;
        border-bottom: 1px solid $light-border;
        h6 {
          font-weight: 600;
          font-size: $px18;
          line-height: $px22;
          letter-spacing: 0.02em;
          color: $font-color;
          text-transform: capitalize;
          margin-bottom: 0;
          span {
            font-weight: 600;
            font-size: $px18;
            line-height: $px22;
            letter-spacing: 0.02em;
            color: $light-font;
          }
        }
        .close_filter {
          margin-left: auto;
        }
      }
      .customized-img {
        width: 100%;
        margin-right: 0;
        border-radius: $px8;
        overflow: hidden;
        padding: $px14 $px18 0 $px18;
        .total-box {
          display: none;
        }
        .bg-size {
          border-radius: $px4;
          &:before {
            padding-top: 54%;
          }
        }
      }
      .customized-detail {
        padding: 0;
        margin-top: $px16;
        width: 100%;
        height: auto;
        overflow: auto;
        .customized-wrapper {
          margin-bottom: $px90;
          /* width */
          ::-webkit-scrollbar {
            width: $px3;
          }
          /* Track */
          ::-webkit-scrollbar-track {
            background: #dce0e5;
            border-radius: $px6;
          }
          /* Handle */
          ::-webkit-scrollbar-thumb {
            background: #b2becf;
            border-radius: $px4;
          }
          /* Handle on hover */
          ::-webkit-scrollbar-thumb:hover {
            background: darken(#dce0e5, 0.2);
          }
          .single-select-section {
            // overflow: hidden;
            // max-height: $px170;
            // overflow-y: auto;
          }
        }
        .modal-bottom {
          position: absolute;
          bottom: -$px50;
          width: 100%;
          left: 0;
          box-shadow: none;
          border-top: 1px solid $light-border;
          padding: $px15 $px15;
          .btn-solid {
            align-items: center;
            padding: $px5 $px24;
            .content {
              padding-left: $px10;
              border-left: $px1 solid rgba(255, 255, 255, 0.4);
              .name {
                font-weight: normal;
                font-size: $px12;
                line-height: $px15;
                letter-spacing: 0.5px;
                color: #ffffff;
                margin-bottom: $px6;
              }
              .price {
                font-weight: 600;
                font-size: $px14;
                line-height: $px17;
                letter-spacing: 0.02em;
                color: #ffffff;
                text-transform: uppercase;
                margin-bottom: 0;
              }
            }
          }
        }
        .customized-description {
          padding-top: 0;
          border-top: none;
          border-bottom: 1px dashed $light-border;
          margin-right: 0;
        }
        .customized-title {
          //display: none;
        }
        .customized-price {
          //display: none;
        }
      }
    }
  }
}
@media (max-width: 575px) {
  .product_page {
    display: block;
    padding: $px16 !important;
    margin: unset;
  }
  .modifier-side-popup {
    right: 0 !important;
    width: 100vw !important;
    max-width: 100% !important;
    display: none;
    &.open-popup {
      display: block;
    }
    &.without-modifier {
      height: 100%;
      bottom: 0;
      top: auto;
      .modal-dialog {
        height: auto;
        .modal-content {
          height: 100vh;
        }
      }
    }
    .customized-modal {
      &.modal-dialog {
        right: 0 !important;
        width: 100vw !important;
        max-width: 100% !important;
        margin: 0;
        transition: none !important;
        transform: none !important;
      }
      .modal-content {
        border: none;
        border-radius: 0;
        max-height: 100%;
      }
      .modal-body {
        .customized-detail {
          height: auto !important;
          .customized-wrapper {
            margin-bottom: $px16 !important;
            .single-select-section {
              max-height: 100%;
              overflow: unset;
            }
          }
        }
        .modal-bottom {
          position: fixed;
          bottom: 0;
          .qty-title {
            display: none;
          }
          .qty-box {
            margin-left: 0;
          }
        }
      }
    }
  }
}
.body-rtl {
  .modifier-side-popup {
    .modal-body {
      .content-header {
        .close_filter {
          margin-left: 0;
        }
      }
    }
  }
}
</style>
